import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaPeriod = Loadable({
  loader: () => import("./Period"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaPeriod;



// WEBPACK FOOTER //
// ./ecology9/wea-period/index.js